import { useCredentials } from '@dentalux/security'
import React, { ReactElement, useEffect, useState } from 'react'
import { Button, CircularProgress, Grid, Typography } from '@material-ui/core'
import GetApp from '@material-ui/icons/GetApp'
import { useTranslation } from 'react-i18next'
import EmptyState from '../../components/EmptyState'
import { DatePicker } from '@material-ui/pickers'
import { PayoutPractitioner } from '../../api/salaryCalculation'
import PractitionersFilter from './components/PractitionersFilter'
import SalaryCalculationContent from './components/SalaryCalculationContent'
import { useGetLatestPayments } from './hooks/useGetLatestPayments'
import useGetPayoutPractitioners from '../../hooks/query/useGetPayoutPractitioners'
import moment, { Moment } from 'moment'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import Checkbox from '@material-ui/core/Checkbox'

const SalaryCalculation = (): ReactElement => {
  const maxDate = moment().subtract(1, 'months')
  const { authentication: user } = useCredentials()
  const { t } = useTranslation()
  const [selectedPractitioner, setSelectedPractitioner] = useState<PayoutPractitioner>()
  const [showDeprecatedEmployees, setShowDeprecatedEmployees] = useState(false)

  const practitionerReferenceId = selectedPractitioner?.referenceId
  const { data: practitioners, refetch } = useGetPayoutPractitioners(showDeprecatedEmployees)
  const refreshPractitioners = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Update the checkbox state
    setShowDeprecatedEmployees(event.target.checked)

    setSelectedPractitioner(undefined)

    // Refetch the data with new parameters
    refetch()
  }

  const [date, setDate] = useState<Moment>(maxDate)
  const { paymentsLoading, downloadLatestPayments } = useGetLatestPayments(date)

  const onChangeDate = (date: MaterialUiPickersDate) => {
    setDate(date as Moment)
  }

  return (
    <Grid container direction="column" spacing={4} justifyContent="space-between">
      <Grid item container spacing={5} alignItems="center">
        <Grid item>
          <PractitionersFilter
            key={`practitioners-${practitioners?.length || 0}-${showDeprecatedEmployees}`}
            onChange={setSelectedPractitioner}
            value={selectedPractitioner}
            practitioners={practitioners}
          />
        </Grid>
        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
          <Checkbox color="primary" checked={showDeprecatedEmployees} value={false} onChange={refreshPractitioners} />
          <Typography style={{ marginLeft: '4px' }}>{t(`show-deprecated`)}</Typography>
        </Grid>
        <Grid item style={{ marginLeft: 'auto' }}>
          {paymentsLoading ? (
            <CircularProgress />
          ) : (
            <>
              <DatePicker
                value={date}
                onChange={onChangeDate}
                minDate={moment('2022-01-01')}
                maxDate={maxDate}
                views={['month', 'year']}
                label={t('pick_month_year')}
                inputVariant="outlined"
                // format="DD.MMM YYYY"
              />
              <Button color="primary" size="large" onClick={downloadLatestPayments}>
                <GetApp fontSize="large" />
                {t('btn_download').toUpperCase()}
              </Button>
            </>
          )}
        </Grid>
      </Grid>

      <Grid item>
        {practitionerReferenceId ? (
          <SalaryCalculationContent practitionerReferenceId={practitionerReferenceId} />
        ) : (
          <EmptyState />
        )}
      </Grid>
    </Grid>
  )
}

export default SalaryCalculation
